/**
 * Where people read how the Hub processes their personal data (GDPR Art. 13)
 * and whom they contact to exercise their rights. Set per deployment at build
 * time; the footer, the login page and Settings link to them when set.
 */
export const PRIVACY_NOTICE_URL = (process.env.REACT_APP_PRIVACY_NOTICE_URL || '').trim();
export const PRIVACY_CONTACT_EMAIL = (process.env.REACT_APP_PRIVACY_CONTACT_EMAIL || '').trim();
